export default __webpack_public_path__ + "static/KeywordResearch_01_02@2x-33f95b23740a3f89ad98d9de603e6658.webp";